import React from 'react';
import {List, ListItem} from '@mui/material';
import Paper from '@mui/material/Paper';
import {listStyle} from 'features/layout/DialogRoutes/dialogs/search/styles';
import {IDiplomatObject} from 'types/DiplomatObject';
import {useTranslation} from 'react-i18next';
import ResultItem from 'features/layout/DialogRoutes/dialogs/search/ResultItem';
import {sortBy} from 'lodash';

type SearchResultsListProps = {
   data: IDiplomatObject[];
};

const SearchResultsList = ({data}: SearchResultsListProps) => {
   const {t} = useTranslation();

   const items = React.useMemo(() => sortBy(data, 'name'), [data]);

   return (
      <List dense component={Paper} variant={'outlined'} style={listStyle}>
         {items.length === 0 ? <ListItem>{t('None Found')}</ListItem> : null}
         {items.map((item) => (
            <ResultItem
               key={item.id}
               id={item.id}
               name={item.name}
               type={item.objectType!}
               folderId={item.folderId}
            />
            // <ListItem
            //    button
            //    key={item.id}
            //    onDoubleClick={() => history.push('/' + packId(item.objectType, item.id))}
            // >
            //    <StateStatusIcon name={item.name} />
            //    {item.name}
            // </ListItem>
         ))}
      </List>
   );
};

export default SearchResultsList;
